import { toJS } from 'mobx'

import type IntegrationStore from '@src/service/integration-store'

import {
  BaseLegacyIntegrationModel,
  type BaseLegacyIntegration,
} from './BaseLegacyIntegrationModel'

interface RawEmailIntegration extends BaseLegacyIntegration {
  readonly type: 'email'
  to: string[]
}

export class EmailIntegrationModel extends BaseLegacyIntegrationModel<RawEmailIntegration> {
  constructor(
    integrationStore: IntegrationStore,
    attrs: Partial<RawEmailIntegration> = {},
  ) {
    const initialValues: RawEmailIntegration = {
      id: '',
      type: 'email',
      events: {},
      phoneNumberId: null,
      createdAt: null,
      to: [],
    }

    super(integrationStore, initialValues, attrs)
  }

  get type(): 'email' {
    return this.raw.type
  }

  get to(): string[] {
    return this.raw.to
  }

  override serialize(): RawEmailIntegration {
    const base = super.serialize()
    return {
      ...base,
      to: toJS(this.raw.to),
    }
  }
}

export const isEmailIntegrationModel = (a: unknown): a is EmailIntegrationModel => {
  return a instanceof EmailIntegrationModel
}

export default EmailIntegrationModel
